// extracted by mini-css-extract-plugin
export default {"step-wrapper":"o5onR","icon-wrapper":"CopWO","icon":"JNGvb","mobile-icon":"DQTYV"};